import { useGetServiceType } from 'hooks/useRequest/form'
import styles from './index.module.scss'

export default function ActivityTypes({ itemClassName, data, justify }) {

    const { data: serviceTypes, isSuccess } = useGetServiceType()

    return (
        <div className={styles.container_activity_types}>
            <div className={styles.title}>حوزه‌های کاری</div>
            <div className={styles.carousel_wrapper + " flex align-i-center flex-wrap gap-5"} style={{ justifyContent: justify ? justify : "center" }}>

                {isSuccess &&
                    serviceTypes.data?.filter(item => data?.includes(item._id))?.map((res, index) =>
                        <div key={index} className='flex align-i-center flex-wrap gap-5' style={{ justifyContent: justify ? justify : "center" }}>
                            <div className={`${styles.activity_item} ${itemClassName}`} >{res.title}</div>
                            {
                                res.name === "cabinet" &&
                                <div className={`${styles.activity_item} ${itemClassName}`} >کمد</div>
                            }
                        </div>
                    )
                }
            </div>
        </div>
    )
}